export default __webpack_public_path__ + "static/media/united-states.6bfa3fc5.svg";